import * as Yup from 'yup';
import { ReviewRequestFormModel } from './types';

const reviewRequestFormValidationSchema: Yup.Schema<Partial<ReviewRequestFormModel>> = Yup.object({
  userName: Yup.string().required('Il campo è obbligatorio'),
  userEmail: Yup.string().email('Inserisci un indirizzo email valido').required('Il campo è obbligatorio'),
});

export default reviewRequestFormValidationSchema;
